<template>
  <v-btn-toggle
    v-model="activeTab"
    mandatory
    color="primary"
  >
    <v-btn small class="px-2" value="balance" :to="{ name: 'rewards' }">Balance</v-btn>
    <v-btn small class="px-2" value="wallet" :to="{ name: 'rewards/wallet' }">Wallet</v-btn>
    <v-btn small class="px-2" value="leaders" :to="{ name: 'rewards/topusers' }">Top Users</v-btn>
    <v-btn small class="px-2" value="more" :to="{ name: 'rewards/earnmore' }">Earn More</v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  name: 'RewardsTabs',

  data: () => ({
    activeTab: 'balance'
  }),
}
</script>